import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  Paper,
  Typography,
  styled,
  Divider,
  CircularProgress,
} from "@mui/material";
import CustomCard from "./CustomCard";
// import TuneIcon from "@mui/icons-material/Tune";
import AddIcon from "@mui/icons-material/Add";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Fab from "@mui/material/Fab";
import DynamicTable from "./customComponents/DynamicTable";
// import CustomFilter from "./customComponents/CustomFilter";
import CustomSearch from "./customComponents/CustomSearch";
import CustomTabs from "./customComponents/CustomTabs";
import ProfileSection from "./ProfileSection";
import DetailsTable from "./customComponents/DetailsTable.js";
import { ArrowBack } from "@mui/icons-material";
import CustomModal from "./customComponents/customModal";
import CustomCalendar from "./customComponents/CustomCalendar";
import AddChargerButton from "./buttonComponents/AddChargerButton";
import AddUserButton from "./buttonComponents/AddUserButton";
import SearchButton from "./buttonComponents/SearchButton";
import FilterButton from "./buttonComponents/FilterButton";
import ExportExcel from "./buttonComponents/ExportExcel";
import DownloadButton from "./buttonComponents/DownloadButton";
import { useSelector, useDispatch } from "react-redux";
import { fetchTableData } from "../slice/TableSlice";
import EmptyData from "./EmptyData";
import noStations from "../assets/emptyData/noStations.svg";
import * as XLSX from "xlsx";
import DynamicFormModal from "./customComponents/DynamicFormModal.js";
import NewDatePicker from "./NewDatePicker.js";
import AddAdminButton from "./buttonComponents/AddAdminButton.js";
import { setSelectedFacility } from "../slice/StationListSlice.js";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { refreshLogsSelectedDate } from "../slice/DateFilterSlice.js";

const ChargingStations = () => {
  const [openModal, setOpenModal] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [showLogs, setShowLogs] = useState(false);
  const [selectedCharger, setSelectedCharger] = useState(null);
  const [timePeriodModalOpen, setTimePeriodModalOpen] = useState(false);
  const [calendarModalOpen, setCalendarModalOpen] = useState(false);
  const [searchedStationList, setSearchedStationList] = useState([]);
  const [searchedChargerData, setSearchedChargerData] = useState([]);
  const [id, setId] = useState();
  // const [isInitialLoad, setIsInitialLoad] = useState(true);       // Previous Logic
  // const [selectedStation, setSelectedStation] = useState(null);   // Previous Logic
  const [searchText, setSearchText] = useState("");
  const [tableSearchText, setTableSearchText] = useState("");
  const [isDynamicModalOpen, setIsDynamicModalOpen] = useState(false);
  const [isStationListOpen, setIsStationListOpen] = useState(true);
  const [dynamicModalType, setDynamicModalType] = useState("");

  const loginStatus = useSelector((state) => state.login);
  const userStatus = useSelector((state) => state.user);
  const facilityStatus = useSelector((state) => state.stationList);
  const detailsStatus = useSelector((state) => state.table);
  const logsStatus = useSelector((state) => state.chargerLogs);
  const facility = useSelector((state) => state.stationList.data.data);
  const tableData = useSelector((state) => state.table.data.data);
  const loggedData = useSelector((state) => state.chargerLogs.data.data);
  const { selectedFacility } = useSelector((state) => state.stationList);
  const { selectedDate } = useSelector((state) => state.datePicker);
  const timeoutRef = useRef();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.user.data.data);

  useEffect(() => {
    // Update searchedStationList when stationList changes
    setSearchedStationList(facility);
    setId(facility?.[0]?.id);
  }, [facility]);

  useEffect(() => {
    const currentTabData = tableData?.tabs[tabValue];
    setSearchedChargerData(currentTabData ? currentTabData.table_content : []);
  }, [tableData, tabValue]);

  const isLoading =
    loginStatus.isLoading || userStatus.isLoading || facilityStatus.isLoading;

  const isTableLoading = detailsStatus.isLoading || logsStatus.isLoading;

  const timePeriods = [
    "This Week",
    "Past Week",
    "Last 30 days",
    "This Month",
    "Past Month",
  ];

  const apiTabs = tableData && tableData.tabs ? tableData.tabs : [];

  // const filterStationData = [
  //   {
  //     name: "state",
  //     label: "Select State",
  //     displayName: "State",
  //     options: ["State A", "State B"],
  //   },
  //   {
  //     name: "city",
  //     label: "Select City",
  //     displayName: "City",
  //     options: ["City A", "City B"],
  //   },
  //   {
  //     name: "cpo",
  //     label: "Select CPO",
  //     displayName: "CPO",
  //     options: ["CPO A", "CPO B"],
  //   },
  //   {
  //     name: "client",
  //     label: "Select Client",
  //     displayName: "Client",
  //     options: ["Client A", "Client B"],
  //   },
  // ];

  const handleSearch = (searchText) => {
    setSearchText(searchText);
    const filteredStationList = facility.filter(
      (data) => {
        const searchTextLowerCase = searchText.toLowerCase();
        return Object.values(data).some((value) => {
          if (typeof value === "string") {
            return value.toLowerCase().includes(searchTextLowerCase);
          } else if (typeof value === "number") {
            return value.toString().toLowerCase().includes(searchTextLowerCase);
          } else if (value && typeof value === "object") {
            return Object.values(value).some((val) => {
              if (typeof val === "string") {
                return val.toLowerCase().includes(searchTextLowerCase);
              } else if (typeof val === "number") {
                return val
                  .toString()
                  .toLowerCase()
                  .includes(searchTextLowerCase);
              }
              return false;
            });
          }
          return false;
        });
      }
      // data.name.toLowerCase().includes(searchText.toLowerCase())
    );
    setSearchedStationList(filteredStationList);
  };

  const handleTabSearch = (searchText) => {
    setTableSearchText(searchText);
    const currentTabData = apiTabs[tabValue];
    if (currentTabData && currentTabData.table_content) {
      const filteredChargerData = currentTabData.table_content.filter(
        (data) => {
          const searchTextLowerCase = searchText.toLowerCase();
          return Object.values(data).some((value) => {
            if (typeof value === "string") {
              return value.toLowerCase().includes(searchTextLowerCase);
            } else if (typeof value === "number") {
              return value
                .toString()
                .toLowerCase()
                .includes(searchTextLowerCase);
            } else if (value && typeof value === "object") {
              return Object.values(value).some((val) => {
                if (typeof val === "string") {
                  return val.toLowerCase().includes(searchTextLowerCase);
                } else if (typeof val === "number") {
                  return val
                    .toString()
                    .toLowerCase()
                    .includes(searchTextLowerCase);
                }
                return false;
              });
            }
            return false;
          });
        }
      );
      setSearchedChargerData(filteredChargerData);
    }
  };
  const handleTabChange = (_event, newValue) => {
    setTabValue(newValue);
    setTableSearchText("");
    const currentTabData = apiTabs[newValue];
    if (currentTabData && currentTabData.table_content) {
      setSearchedChargerData(currentTabData.table_content);
    }
  };

  const handleisFabModalOpen = () => {
    const newApiCallType = "addCharger";
    localStorage.setItem("dynamicModalType", newApiCallType);
    setDynamicModalType(newApiCallType);
    setIsDynamicModalOpen(true);
  };

  const handleStationModalOpen = () => {
    const newApiCallType = "addStation";
    localStorage.setItem("dynamicModalType", newApiCallType);
    setDynamicModalType(newApiCallType);
    setIsDynamicModalOpen(true);
  };

  const handleUserModalOpen = () => {
    const newApiCallType = "addUser";
    localStorage.setItem("dynamicModalType", newApiCallType);
    setDynamicModalType(newApiCallType);
    setIsDynamicModalOpen(true);
  };

  const handleAdminModalOpen = () => {
    const newApiCallType = "addAdmin";
    localStorage.setItem("dynamicModalType", newApiCallType);
    setDynamicModalType(newApiCallType);
    setIsDynamicModalOpen(true);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleApplyFilter = () => {
    // Implement filter logic here
    handleCloseModal();
  };
  const handleResetFilter = () => {
    // Implement your logic for resetting filters
  };

  const handleTimePeriodModalOpen = () => {
    setTimePeriodModalOpen(true);
  };

  const handleTimePeriodModalClose = () => {
    setTimePeriodModalOpen(false);
  };

  const handleCustomDateClick = () => {
    setTimePeriodModalOpen(false);
    setCalendarModalOpen(true);
  };

  const handleCalendarModalClose = () => {
    setCalendarModalOpen(false);
  };

  const handleCalendarApply = () => {
    // Implement logic for applying calendar selection
    handleCalendarModalClose();
  };

  const handleCalendarClear = () => {
    // Implement logic for clearing calendar selection
  };

  const handleExportToExcelClick = () => {
    const ws = XLSX.utils.json_to_sheet([]);
    const wb = XLSX.utils.book_new();

    const currentTabData = tableData.tabs[tabValue];
    let buttonTabs = [];
    if (
      Array.isArray(currentTabData.table_content) &&
      currentTabData.table_content.length > 0
    ) {
      const values = Object.entries(currentTabData.table_content[0]);
      values?.forEach((item) => {
        if (item[1]?.type === "button" || item[1]?.type === "toggle")
          buttonTabs.push(item[0]);
      });
    }

    const headers = currentTabData.headers
      .filter(
        (header) =>
          header.id !== "id" &&
          header.id !== "edit" &&
          header.id !== "currency" &&
          !buttonTabs.includes(header.id)
      )
      .map((header) => header?.label);

    // Add headers to the worksheet
    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A1" });

    let tableContent = [];
    if (Array.isArray(currentTabData.table_content)) {
      tableContent = currentTabData.table_content.map((item) => {
        const rowData = currentTabData.headers
          .filter(
            (header) =>
              header.id !== "id" &&
              header.id !== "edit" &&
              header.id !== "currency" &&
              !buttonTabs.includes(header.id)
          )
          .map((header) => {
            const value = item[header.id];
            if (header.id === "view_graph")
              return JSON.stringify(value).length > 32767
                ? JSON.stringify(value).substring(0, 32767)
                : JSON.stringify(value);
            return typeof value === "object" ? value?.label : value;
          });
        return rowData;
      });
    }

    // Add table content to the worksheet
    XLSX.utils.sheet_add_aoa(ws, tableContent, { origin: "A2" });

    let sheetName = "Sheet1";
    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    let fileName = "file";
    if (currentTabData.name === "Chargers" || currentTabData.name === "Admins")
      fileName = `${selectedFacility?.name}_${currentTabData?.name}`;
    else if (currentTabData.name === "Users")
      fileName = `${selectedFacility?.name}_restricted_users`;
    else if (currentTabData.name === "Sessions") {
      const start_date = selectedDate?.start;
      const end_date = selectedDate?.end;
      const date_string = `${start_date.getDate()}-${start_date.getMonth()}-${start_date.getFullYear()} - ${end_date.getDate()}-${end_date.getMonth()}-${end_date.getFullYear()}`;
      fileName = `${selectedFacility?.name}_${date_string}`;
    }
    // Save Excel file
    fileName = `${fileName.toLowerCase()}.xlsx`;
    XLSX.writeFile(wb, fileName);
  };

  function formatDate(date) {
    try {
      const formattedDate = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
      };
      const dateObject = new Date(date);
      const formatted = dateObject.toLocaleString("en-US", formattedDate);
      return formatted;
    } catch {
      return " ";
    }
  }

  const handleDownloadClick = () => {
    const ws = XLSX.utils.json_to_sheet([]);
    const wb = XLSX.utils.book_new();

    const headers = loggedData?.tabs?.[0]?.headers
      .filter((header) => header.id !== "extra")
      .map((header) => header?.label);

    // Add headers to the worksheet
    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A1" });

    let tableContent = [];
    if (Array.isArray(loggedData?.tabs?.[0]?.table_content)) {
      tableContent = loggedData?.tabs?.[0]?.table_content.map((item) => {
        const rowData = loggedData?.tabs?.[0]?.headers
          .filter((header) => header.id !== "extra")
          .map((header) => {
            const value = item[header.id];
            if (header.id === "updated_at")
              return value ? formatDate(value) : "";
            return typeof value === "object" && !Array.isArray(value)
              ? JSON.stringify(value?.content)
              : value;
          });
        return rowData;
      });
    }

    // Add table content to the worksheet
    XLSX.utils.sheet_add_aoa(ws, tableContent, { origin: "A2" });
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    const device_id = loggedData?.tabs[0]?.name?.split(" ");
    const fileName = (
      device_id?.length > 0 ? device_id.at(-1) : "charger"
    )?.toLowerCase();
    XLSX.writeFile(wb, `${fileName}_logs_data.xlsx`);
  };

  const handleAllStationDownloadClick = () => {
    const ws = XLSX.utils.json_to_sheet([]);
    const wb = XLSX.utils.book_new();

    const facilities = facility || [];

    if (!facilities.length) return;

    const headers = Object.keys(facilities[0]).filter((key) => key !== "extra");

    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A1" });

    const tableContent = facilities.map((item) => {
      return headers.map((key) => {
        const value = item[key];
        if (typeof value === "object" && value !== null) {
          return JSON.stringify(value);
        }
        return value;
      });
    });

    XLSX.utils.sheet_add_aoa(ws, tableContent, { origin: "A2" });
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    const fileName = "all_stations";

    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  const handleShowLogsChange = (value) => {
    setShowLogs(value);
  };

  const debouncedHandleCardClick = (stationId, selectedDate) => {
    const startISOString = selectedDate?.startForDetails
      ?.toISOString()
      ?.split("T")[0];
    const endISOString = selectedDate?.end?.toISOString()?.split("T")[0];
    dispatch(
      fetchTableData({
        stationId: stationId,
        startDate: startISOString,
        endDate: endISOString,
      })
    );
  };

  const handleCardClick = (stationId) => {
    const selectedStation = searchedStationList.find(
      (station) => station.id === stationId
    );
    if (selectedStation) {
      localStorage.setItem("selectedStation", JSON.stringify(selectedStation)); // Previous Logic
      // setSelectedStation(selectedStation);    // Previous Logic
      dispatch(setSelectedFacility(selectedStation));
      setSearchText((prevSearchText) => prevSearchText);
    }
    setTableSearchText("");
    setTabValue(0);
    setShowLogs(false);
    setId(stationId);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      debouncedHandleCardClick(stationId, selectedDate);
    }, 100);
  };

  const handleBackArrowClick = () => {
    setShowLogs(false);
    setTableSearchText((prevSearchText) => prevSearchText);
  };

  const handleSearchButton = (searchText) => {
    handleTabSearch(searchText);
  };

  useEffect(() => {
    if (showLogs) dispatch(refreshLogsSelectedDate("hel"));
  }, [showLogs]);

  const renderButtons = (tab_content = false, logs_date = false) => {
    const currentTabData = tab_content ? tab_content : apiTabs[tabValue];

    if ((currentTabData && currentTabData.filters_and_buttons) || tab_content) {
      const placeholder = `Search ${currentTabData.name || "Item"}`;
      return currentTabData.filters_and_buttons.map((button, index) => {
        switch (button) {
          case "Add Charger":
            return (
              <AddChargerButton
                key={`tabs-${index}`}
                onClick={() => handleisFabModalOpen()}
              />
            );
          case "Add User":
            return (
              <AddUserButton
                key={`tabs-${index}`}
                onClick={() => handleUserModalOpen()}
              />
            );
          case "Add Admin":
            return (
              <AddAdminButton
                key={`tabs-${index}`}
                onClick={() => handleAdminModalOpen()}
              />
            );
          case "Search":
            return (
              <SearchButton
                key={`tabs-${index}`}
                placeholder={placeholder}
                handleOnSearch={(searchText) => handleSearchButton(searchText)}
                value={tableSearchText}
              />
            );
          case "Filters":
            return (
              <FilterButton key={`tabs-${index}`} onClick={handleOpenModal} />
            );
          case "date_range_filter":
            return logs_date ? (
              <NewDatePicker
                facilityId={selectedFacility?.id}
                logs_date={true}
              />
            ) : (
              <NewDatePicker facilityId={selectedFacility?.id} />
            );
          case "Export to Excel":
            return (
              <ExportExcel
                key={`tabs-${index}`}
                onClick={handleExportToExcelClick}
              />
            );
          case "Download":
            return (
              <DownloadButton
                key={`tabs-${index}`}
                onClick={handleExportToExcelClick}
              />
            );
          default:
            return null;
        }
      });
    }
  };

  const StyledFab = styled(Fab)({
    zIndex: 1,
    top: -45,
    color: "#fff",
    background: "#467CEB",
    "&:hover": {
      background: "#467CEB",
    },
  });

  useEffect(() => {
    const startISOString = selectedDate?.startForDetails
      ?.toISOString()
      ?.split("T")[0];
    const endISOString = selectedDate?.end?.toISOString()?.split("T")[0];
    if (selectedFacility?.name !== "All" && id) {
      dispatch(
        fetchTableData({
          stationId: selectedFacility?.id,
          startDate: startISOString,
          endDate: endISOString,
        })
      );
    }
  }, [dispatch, selectedDate, selectedFacility, id]);

  const handleSidebarOpen = () => {
    setIsStationListOpen(false);
  };

  return (
    <>
      {isLoading && (
        <Grid sx={{ position: "absolute", top: "50%", left: "50%" }}>
          <CircularProgress />
        </Grid>
      )}
      {!isLoading && (
        <>
          <Grid
            container
            rowSpacing={3}
            columnSpacing={3}
            alignItems="center"
            style={{ backgroundColor: "white", marginBottom: "20px" }}
          >
            <Grid
              item
              xs={8}
              style={{
                flexGrow: 1,
                padding: "0 20px",
                alignItems: "center",
                display: "flex",
              }}
            >
              <Typography variant="h4" fontSize="20px" fontWeight="600">
                {selectedFacility?.name !== "All"
                  ? `${selectedFacility?.name} - Station`
                  : "Station Management - Station List"}
              </Typography>
            </Grid>
            <Grid item xs={4} style={{ paddingTop: "5px" }}>
              <ProfileSection />
            </Grid>
          </Grid>
          <Grid
            container
            rowSpacing={3}
            columnSpacing={3}
            sx={{ marginTop: 1, marginLeft: "-16px" }}
          >
            {isStationListOpen ? (
              <Grid
                item
                xs={12}
                md={3}
                sx={{
                  borderRadius: "16px",
                  background: "#FFF",
                  boxShadow: "0px 4px 32px 0px rgba(152, 162, 179, 0.12)",
                  padding: "16px",
                }}
              >
                <Grid
                  container
                  sx={{ padding: 0 }}
                  rowSpacing={3}
                  columnSpacing={3}
                >
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "12px",
                    }}
                  >
                    <CustomSearch
                      placeholder="Search Station"
                      onSearch={handleSearch}
                      value={searchText}
                    />
                    <Grid
                      onClick={handleSidebarOpen}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        alignSelf: "stretch",
                        background: "var(--color-styles-white, #FFF)",
                        cursor: "pointer",
                      }}
                    >
                      <CloseIcon
                        sx={{
                          display: "flex",
                          width: "24px",
                          height: "24px",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                      ></CloseIcon>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    display={"flex"}
                    justifyContent="space-between"
                    alignItems={"center"}
                  >
                    <h4 style={{ margin: "0" }}>
                      {searchedStationList?.length > 0
                        ? `${searchedStationList?.length} Stations`
                        : "0 Station"}
                    </h4>
                    {(userData?.facility_admin_type === "superadmin" ||
                      userData?.facility_admin_type === "countryadmin") && (
                      <DownloadButton
                        onClick={handleAllStationDownloadClick}
                        button_text={"Download All"}
                      />
                    )}
                  </Grid>
                  {searchedStationList?.length > 0 ? (
                    <Grid
                      item
                      xs={12}
                      sx={{
                        maxHeight: "calc(100vh - 260px)",
                        overflow: "auto",
                      }}
                    >
                      <PerfectScrollbar
                        sx={{
                          overflow: "auto",
                          maxHeight: "100%",
                          scrollbarWidth: "thin", // For Firefox
                        }}
                      >
                        {Array.isArray(searchedStationList) &&
                          searchedStationList?.map((station) => (
                            <CustomCard
                              key={station?.id}
                              cardData={station}
                              onClick={() => handleCardClick(station.id)}
                              isSelected={selectedFacility?.id === station.id}
                              onSelect={() => handleCardClick(station.id)}
                            />
                          ))}
                        <Grid
                          position="fixed"
                          color="primary"
                          display={
                            userStatus?.data?.data?.add_station
                              ? "block"
                              : "none"
                          }
                          sx={{ bottom: "15px", left: "22%" }}
                          onClick={handleStationModalOpen}
                        >
                          <StyledFab
                            color="#467CEB"
                            background="#467CEB"
                            aria-label="add"
                          >
                            <AddIcon sx={{ fontSize: "30px" }} />
                          </StyledFab>
                        </Grid>
                      </PerfectScrollbar>
                    </Grid>
                  ) : (
                    <EmptyData
                      imagePath={noStations}
                      message="No Stations Found"
                    />
                  )}
                </Grid>
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                md={0.5}
                sx={{
                  borderRadius: "16px",
                  background: "#FFF",
                  boxShadow: "0px 4px 32px 0px rgba(152, 162, 179, 0.12)",
                  padding: "1px",
                  paddingLeft: "0px",
                }}
                style={{
                  paddingLeft: "15px",
                  height: "calc(100vh - 100px)",
                  display: "flex",
                }}
              >
                <Grid
                  container
                  sx={{ padding: 0 }}
                  rowSpacing={0}
                  columnSpacing={0}
                >
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "1px",
                    }}
                  >
                    <Grid
                      onClick={() => setIsStationListOpen(true)}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        alignSelf: "stretch",
                        background: "var(--color-styles-white, #FFF)",
                        cursor: "pointer",
                      }}
                    >
                      <ArrowForwardIosIcon
                        sx={{
                          display: "flex",
                          width: "24px",
                          height: "24px",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                      ></ArrowForwardIosIcon>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}
            {/* </Grid> */}
            {isTableLoading ? (
              <Grid sx={{ position: "absolute", top: "50%", left: "60%" }}>
                <CircularProgress />
              </Grid>
            ) : selectedFacility?.name === "All" ? (
              <Typography
                variant="h5"
                style={{ position: "absolute", top: "50%", left: "50%" }}
              >
                Please select a station to see the data
              </Typography>
            ) : (
              <Grid
                item
                xs={isStationListOpen ? 9 : 11.5}
                sx={{ paddingTop: "0" }}
                style={{ paddingTop: "0" }}
              >
                <Grid item xs={12}>
                  <Paper
                    sx={{
                      borderRadius: "16px",
                      background: "#fff",
                      boxShadow: "none",
                    }}
                  >
                    <Grid
                      sx={{
                        display: "flex",
                        padding: "16px 16px 0 16px",
                        alignItems: "flex-start",
                        alignSelf: "stretch",
                      }}
                    >
                      <Grid sx={{ width: "100%" }}>
                        {showLogs ? (
                          <>
                            <Grid
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                paddingTop: "16px",
                                paddingBottom: "32px",
                              }}
                            >
                              <ArrowBack
                                sx={{ cursor: "pointer" }}
                                onClick={handleBackArrowClick}
                              />
                              <Typography
                                sx={{
                                  color: "var(--light-mode-gray-80, #001233)",
                                  fontFamily: "Inter",
                                  fontSize: "20px",
                                  fontStyle: "normal",
                                  fontWeight: "600",
                                  lineHeight: "normal",
                                }}
                              >
                                {loggedData?.tabs[0].name}
                              </Typography>
                            </Grid>
                            {loggedData?.tabs[0]?.table_content && (
                              <Grid
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                {/* <Button
                                    onClick={handleTimePeriodModalOpen}
                                    sx={{
                                      border: "1px solid #EAEBEE",
                                      borderRadius: "8px",
                                      color: "#5C677D",
                                      textTransform: "capitalize",
                                      padding: "8px 16px",
                                    }}
                                  >
                                    Time Period{" "}
                                    <ExpandMore sx={{ marginLeft: "16px" }} />
                                  </Button> */}

                                {loggedData?.tabs[0]?.filters_and_buttons
                                  ?.length > 0 &&
                                  renderButtons(loggedData?.tabs[0], true)}

                                {loggedData?.tabs[0]?.table_content.length >
                                  0 && (
                                  <DownloadButton
                                    onClick={handleDownloadClick}
                                  />
                                )}
                              </Grid>
                            )}
                            <CustomModal
                              open={timePeriodModalOpen}
                              onClose={handleTimePeriodModalClose}
                            >
                              {timePeriods.map((timePeriod) => (
                                <Typography
                                  key={timePeriod}
                                  onClick={() => setTimePeriodModalOpen(false)}
                                  sx={{
                                    cursor: "pointer",
                                    marginBottom: "16px",
                                  }}
                                >
                                  {timePeriod}
                                </Typography>
                              ))}
                              {timePeriods?.length > 0 && (
                                <Divider
                                  sx={{ margin: "8px 0", width: "100%" }}
                                />
                              )}
                              {/* Custom Date text with + icon */}
                              <Grid
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                                onClick={handleCustomDateClick}
                              >
                                <AddIcon sx={{ marginRight: "8px" }} />
                                <Typography>Custom Date</Typography>
                              </Grid>
                            </CustomModal>
                          </>
                        ) : (
                          <CustomTabs
                            formTabs={apiTabs}
                            tabValue={tabValue}
                            handleTabChange={handleTabChange}
                          />
                        )}
                      </Grid>
                    </Grid>
                    <Grid
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "12px",
                        margin: "16px 20px",
                        justifyContent: "space-between",
                      }}
                    >
                      {showLogs ? null : renderButtons()}
                    </Grid>
                    {showLogs ? (
                      <DetailsTable detailsData={loggedData} />
                    ) : (
                      <DynamicTable
                        setSelectedData={setSelectedCharger}
                        selectedData={selectedCharger}
                        tabValue={tabValue}
                        searchedData={searchedChargerData}
                        tabs={tableData?.tabs}
                        onEditClick={handleisFabModalOpen}
                        onShowLogsChange={handleShowLogsChange}
                      />
                    )}
                  </Paper>
                </Grid>
              </Grid>
            )}
            <DynamicFormModal
              isOpen={isDynamicModalOpen}
              onClose={() => setIsDynamicModalOpen(false)}
              apiCallType={dynamicModalType}
              id={id}
            />
            <CustomCalendar
              open={calendarModalOpen}
              onClose={handleCalendarModalClose}
              onApply={handleCalendarApply}
              onClear={handleCalendarClear}
            />
          </Grid>
        </>
      )}
    </>
  );
};

export default ChargingStations;
